exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar[data-v-6f91eaf2]{position:sticky;top:0;z-index:10;background:#fff;border-radius:4px;border-bottom:1px solid #e6ebf5}.mr-5[data-v-6f91eaf2]{margin-right:5px}", ""]);

// exports
